(function ($) {
   function resizeSlidesContainers() {
      $(".wp-block-content-grid").each(function () {
         var contentGrid = $(this);

         // Slides containers height
         var slidesContainers = contentGrid.find(".slides-container");

         slidesContainers.each(function (index, slideContainerEl) {
            var slideContainer = $(slideContainerEl);
            var slideCards = slideContainer.find(".slide-card");
            var slidesContainerHeight = 0;
            slideCards.each(function (index, card) {
               if (card.offsetHeight > slidesContainerHeight) {
                  slidesContainerHeight = card.offsetHeight;
               }
            });
            slideContainer.css("height", slidesContainerHeight);
         });
      });
   }

   $(window).on("resize", resizeSlidesContainers);

   $(function () {
      $(".wp-block-content-grid").each(function () {
         var contentGrid = $(this);

         resizeSlidesContainers();

         // Swipe handling
         let touchStartX = 0;
         let touchEndX = 0;
         contentGrid.on("touchstart", function (e) {
            if (!$(e.target).closest(".lightbox-gallery-thumbnail-strip").length) {
               touchStartX = e.originalEvent.touches[0].clientX;
            }
         });
         contentGrid.on("touchend", function (e) {
            if (!$(e.target).closest(".lightbox-gallery-thumbnail-strip").length) {
               touchEndX = e.originalEvent.changedTouches[0].clientX;
               if (touchEndX < touchStartX - 50) {
                  changeSlide("next");
               } else if (touchEndX > touchStartX + 50) {
                  changeSlide("prev");
               }
            }
         });

         // Shared slider change function
         function changeSlide(directionOrIndex) {
            var items = contentGrid.find(".slide-card:visible");

            if (items.length < 2) return;

            var thumbnails = contentGrid.find(".pagination-style:visible");
            var currentIndex = items.filter(".active:visible").index();
            var newIndex;

            if (typeof directionOrIndex === "number") {
               newIndex = directionOrIndex;
            } else {
               newIndex = directionOrIndex === "next" ? (currentIndex + 1) % items.length : (currentIndex - 1 + items.length) % items.length;
            }

            items.removeClass("prev active next");
            thumbnails.removeClass("active");

            items.eq(newIndex).addClass("active");
            thumbnails.eq(newIndex).addClass("active");

            // Add prev/next classes for animation direction
            items.eq((newIndex - 1 + items.length) % items.length).addClass("prev");
            items.eq((newIndex + 1) % items.length).addClass("next");

            scrollToActiveThumbnail();
         }

         // Scroll active thumbnail into view
         function scrollToActiveThumbnail() {
            var container = contentGrid.find(".lightbox-gallery-thumbnail-strip");
            var activeItem = container.find(".lightbox-gallery-thumbnail-strip-item.active");
            if (activeItem.length) {
               var scrollPos = activeItem.position().left + container.scrollLeft();
               container.animate(
                  {
                     scrollLeft: scrollPos - container.width() / 2 + activeItem.outerWidth() / 2,
                  },
                  300
               );
            }
         }

         // Prev/Next button events
         contentGrid.find(".transaction-buttons .prev").on("click", function () {
            changeSlide("prev");
         });
         contentGrid.find(".transaction-buttons .next").on("click", function () {
            changeSlide("next");
         });

         contentGrid.find(".pagination-style").on("click", function () {
            var index = $(this).index();
            changeSlide(index);
         });

         changeSlide(0);
      });
   });
})(jQuery);
